import MainPagePortalSeguranca from '@/screens/portal/seguranca/MainPage'
import { items } from './routes'
import localStorage, { KEYS } from '@/store/local/localStorage'
import store from '@/store'

function beforeEnterLogout (to, from, next) {
  localStorage.removeItem(KEYS.LOGIN.jwt)
  localStorage.removeItem(KEYS.LOGIN.usuario)
  localStorage.removeItem(KEYS.LOGIN.token)
  store.dispatch('auth/logout')
  next('/login')
}

const portalSeguranca = [
  {
    path: '/portalSeguranca',
    name: 'portalSeguranca',
    component: MainPagePortalSeguranca,
    meta: {
      isPublic: true
    },
    children: [...items]
  },
  {
    path: '/logout',
    name: 'logout',
    meta: {
      isPublic: true
    },
    beforeEnter: beforeEnterLogout
  }
]

export default portalSeguranca



// WEBPACK FOOTER //
// ./src/router/seguranca/index.js